import { ImageContext } from "utils/files/useFilePathContext"
import { useSuspenseQuery } from "@tanstack/react-query"
import { trpc } from "app/trpc"
import { useMemo } from "react"
import * as fncs from "utils/files/getFilePath"
import type { Prefixes } from "utils/files/types"

function FilePathProviderInner({
  children,
  prefixes,
}: {
  children: React.ReactNode
  prefixes: Prefixes
}) {
  const getFilePath = useMemo(() => fncs.getFilePath(prefixes), [prefixes])
  const getFileVariantUrl = useMemo(
    () => fncs.getFileVariantUrl(prefixes),
    [prefixes]
  )

  return (
    <ImageContext.Provider value={{ getFilePath, getFileVariantUrl }}>
      {children}
    </ImageContext.Provider>
  )
}

function FilePathProviderFromQuery({
  children,
}: {
  children: React.ReactNode
}) {
  const { data: prefixes } = useSuspenseQuery({
    ...trpc.files.getFileUrlPrefix.queryOptions(),
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
  })

  return (
    <FilePathProviderInner prefixes={prefixes}>
      {children}
    </FilePathProviderInner>
  )
}

const FilePathProvider = ({
  children,
  prefixes,
}: {
  children: React.ReactNode
  prefixes?: Prefixes
}) => {
  if (prefixes) {
    return (
      <FilePathProviderInner prefixes={prefixes}>
        {children}
      </FilePathProviderInner>
    )
  }

  return <FilePathProviderFromQuery>{children}</FilePathProviderFromQuery>
}

export default FilePathProvider
